import events from '../../actions/event-names';
import Config from '../../config';
import { showSuccess, showError } from '../../utils';


const userRegIniState = {
    userRegErrors: '',
    userRegCurrentStep: 1,
    isOtpResend: false,
    isOtpSubmited: false,
    otpSubmitErrors: '',
}


const initialState = {
    isCheckLoginComplete: false,
    isUserLoginComplete: false,
    availableLanguages: [],
    ...userRegIniState,
};


function getHeader(action) {
    return {
        authorization: ['Bearer', action.payload.data.access_token].join(' '),
    };
}
function setLoginComplete(state, action) {
    return {
        ...state,
        isCheckLoginComplete: 'FULFILLED',
        isUserLoginComplete: 'FULFILLED',
        headers: {
            ...getHeader(action),
        },
        ...action.payload.data,
    };
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
    
    case `${events.CLEAR_USER_LOGIN}`: {
        return {
            ...initialState,
        };
    } 

    // CHECK LOGIN
    case `${events.CHECK_LOGIN}_PENDING`: {
        return {
            ...state,
            isCheckLoginComplete: 'PENDING',
        };
    }

    case `${events.CHECK_LOGIN}_FULFILLED`: {
        return setLoginComplete(state, action)
    }
    case `${events.CHECK_LOGIN}_REJECTED`: {
        if(window.location.hash !== '#/register') {
            window.location.hash = '/';
        }
        return {
            ...state,
            isCheckLoginComplete: 'REJECTED',
        };
    }

    // USER LOGIN
    case `${events.USER_LOGIN}_PENDING`: {
        return {
            ...initialState,
            isUserLoginComplete: 'PENDING',
        };
    }
    case `${events.USER_LOGIN}_FULFILLED`:  {
        window.location.reload()
        return setLoginComplete(state, action)
    }
    case `${events.USER_LOGIN}_REJECTED`: {
        showError(action.payload.response.data.error)
        return {
            ...state,
            isUserLoginComplete: 'REJECTED',
        };
    }

    //  LOGOUT
    case `${events.LOGOUT}_PENDING`: {
        return {
            ...state,
        };
    }
    case `${events.LOGOUT}_FULFILLED`: {
        window.location.href = Config.siteRoot
        return {
            ...state,
        };
    }
    case `${events.LOGOUT}_REJECTED`: {
        window.location.href = Config.siteRoot
        return {
            ...state,
        };
    }

    case `${events.GET_AVL_LANGUAGES}_FULFILLED`: {
        return {
            ...state,
            availableLanguages: action.payload.data,
        };
    }

    // USER_REGISTRATION
    case `${events.USER_REGISTRATION}_PENDING`: {
        return {
            ...state,
            isUserRegistered: 'PENDING',
        };
    }
    case `${events.USER_REGISTRATION}_FULFILLED`: {
        return {
            ...state,
            userRegErrors: "",
            userRegCurrentStep: 2,
            isUserRegistered: 'FULFILLED',
        };
    }
    case `${events.USER_REGISTRATION}_REJECTED`: {
        return {
            ...state,
            userRegErrors: action.payload.response.data.errors,
            isUserRegistered: 'REJECTED',
        };
    }
    case `${events.CLEAR_USER_REGISTRATION}`: {
        return {
            ...state,
            ...userRegIniState,
        };
    }

    //SUBMIT_USER_REG_OTP
    case `${events.SUBMIT_USER_REG_OTP}_PENDING`: {
        return {
            ...state,
            isOtpSubmited: 'PENDING'
        };
    }
    case `${events.SUBMIT_USER_REG_OTP}_FULFILLED`: {
        window.location.hash = '/';
        window.location.reload()
        showSuccess('OTP submited successfully')
        state.isOtpSubmited = 'FULFILLED';
        return setLoginComplete(state, action)
    }
    case `${events.SUBMIT_USER_REG_OTP}_REJECTED`: {
        if(action.payload.response && action.payload.response.data.error) {
            showError(action.payload.response.data.error)
        }
        return {
            ...state,
            otpSubmitErrors: action.payload.response.data.errors,
            isOtpSubmited: 'REJECTED'
        };
    }

    //RESEND_USER_REG_OTP
    case `${events.RESEND_USER_REG_OTP}_PENDING`: {
        return {
            ...state,
            isOtpResend: 'PENDING',
        };
    }
    case `${events.RESEND_USER_REG_OTP}_FULFILLED`: {
        showSuccess('OTP resend successfully')
        return {
            ...state,
            isOtpResend: 'FULFILLED',
        };
    }
    case `${events.RESEND_USER_REG_OTP}_REJECTED`: {
        if(action.payload.response && action.payload.response.data.error) {
            showError(action.payload.response.data.error)
        }
        return {
            ...state,
            isOtpResend: 'REJECTED',
        };
    }


    //RESEND_USER_REG_OTP
    case `${events.RESET_PASSWORD}_PENDING`: {
        return {
            ...state,
            isPasswordReset: 'PENDING',
        };
    }
    case `${events.RESET_PASSWORD}_FULFILLED`: {
        showSuccess('Updated successfully')
        return {
            ...state,
            isPasswordReset: 'FULFILLED',
        };
    }
    case `${events.RESET_PASSWORD}_REJECTED`: {
        if(action.payload.response && action.payload.response.data.error) {
            showError(action.payload.response.data.error)
        }
        return {
            ...state,
            isPasswordReset: 'REJECTED',
        };
    }

    



    default:
        return state;
    }
}
